<template>
    <template v-for="(fragment, index) in fragments" :key="`${index}-${fragment.text}`">
        <a
            v-if="fragment.href"
            :href="fragment.href"
            class="blog-rich-text__link text-primary"
            target="_blank"
            rel="noopener noreferrer"
            @click="handleLinkClick($event, fragment.href)"
        >
            <span :class="getClasses(fragment)">{{ fragment.text }}</span>
        </a>
        <span v-else :class="getClasses(fragment)">{{ fragment.text }}</span>
    </template>
</template>

<script>
import { trackArticleLinkConversion } from '@/assets/js/blog/tracking'

export default {
    name: 'NotionRichText',
    props: {
        fragments: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        handleLinkClick(clickEvent, url) {
            trackArticleLinkConversion(clickEvent, url)
        },
        getClasses(fragment) {
            return {
                'font-medium': fragment.annotations?.bold,
                'font-italic': fragment.annotations?.italic,
                'underline': fragment.annotations?.underline,
                'line-through': fragment.annotations?.strikethrough,
                'font-mono': fragment.annotations?.code,
            }
        },
    },
}
</script>

<style scoped>
.blog-rich-text__link {
    text-decoration-color: rgba(15, 23, 42, 0.35);
}

.blog-rich-text--bold {
    font-weight: 700;
}

.blog-rich-text--italic {
    font-style: italic;
}

.blog-rich-text--underline {
    text-decoration: underline;
}

.blog-rich-text--strike {
    text-decoration: line-through;
}

.blog-rich-text--code {
    font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
    font-size: 0.95em;
    background: #e2e8f0;
    border-radius: 0.35rem;
    padding: 0.15rem 0.35rem;
}
</style>
